// src/pages/Admin/ReglementInscription/reglement.helpers.js

export const CHUNK = 60;

export const STATUTS_REGLEMENT = [
  "Réglé",
  "Partiellement réglé",
  "En cours",
  "Non réglé",
  "Problème",
  "Annulé",
];

export const TYPES_REGLEMENT = [
  "En ligne",
  "Chèque",
  "Espèces",
  "Virement",
  "CB",
  "HelloAsso",
  "Chèques Vacances",
  "Coupons Sports",
  "Autre",
];

export function fmtEUR(value) {
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 2,
  }).format(Number(value || 0));
}

export function extractArray(data) {
  if (Array.isArray(data)) return data;

  if (data && typeof data === "object") {
    if (Array.isArray(data.rows)) return data.rows;
    if (Array.isArray(data.items)) return data.items;
    if (Array.isArray(data.data)) return data.data;
    if (Array.isArray(data.reglements)) return data.reglements;
  }

  return [];
}

export function getStoredUserInfo() {
  try {
    const raw = localStorage.getItem("userInfo");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function getRoleId(user) {
  return Number(user?.role_id || user?.roleId || user?.role?.id || 0);
}

export function normalizeText(value) {
  return String(value || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();
}

export function neighborsFromSeason(season) {
  const match = /^(\d{4})\s*-\s*(\d{4})$/.exec(String(season || ""));

  if (!match) return [season].filter(Boolean);

  const y1 = Number(match[1]);
  const y2 = Number(match[2]);

  return [`${y1 - 1}-${y2 - 1}`, `${y1}-${y2}`, `${y1 + 1}-${y2 + 1}`];
}

export function getReglementId(reglement) {
  return reglement?.id ?? reglement?.reglement_id ?? reglement?.ReglementInscription?.id;
}

export function getAdherentName(reglement) {
  const adherent = reglement?.Adherent || reglement || {};
  const nom = String(adherent?.nom || "").trim().toUpperCase();
  const prenom = String(adherent?.prenom || "").trim();

  return `${nom} ${prenom}`.trim() || "Adhérent";
}

export function getGroupsText(reglement) {
  const adherent = reglement?.Adherent || {};
  const groups = Array.isArray(adherent?.Groups) ? adherent.Groups : [];

  return groups.map((group) => group?.nom).filter(Boolean).join(", ");
}

export function toNumber(value) {
  if (value === "" || value === null || value === undefined) return 0;
  return Number(String(value).replace(",", ".")) || 0;
}

export function calculateReglementTotal(reglement) {
  return (
    toNumber(reglement?.montant_lic_assurance) +
    toNumber(reglement?.montant_cotisation) +
    toNumber(reglement?.reduction_foyer) +
    toNumber(reglement?.pass_sport) +
    toNumber(reglement?.reduction_saison)
  );
}

export function getStatusDisplay(status) {
  switch (String(status || "").trim()) {
    case "Réglé":
      return {
        label: "Réglé",
        className:
          "bg-emerald-50 text-emerald-700 ring-emerald-200 dark:bg-emerald-500/10 dark:text-emerald-300 dark:ring-emerald-500/20",
      };

    case "Partiellement réglé":
      return {
        label: "Partiellement réglé",
        className:
          "bg-amber-50 text-amber-700 ring-amber-200 dark:bg-amber-500/10 dark:text-amber-300 dark:ring-amber-500/20",
      };

    case "En cours":
      return {
        label: "En cours",
        className:
          "bg-indigo-50 text-indigo-700 ring-indigo-200 dark:bg-indigo-500/10 dark:text-indigo-300 dark:ring-indigo-500/20",
      };

    case "Non réglé":
      return {
        label: "Non réglé",
        className:
          "bg-slate-100 text-slate-700 ring-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:ring-slate-700",
      };

    case "Problème":
      return {
        label: "Problème",
        className:
          "bg-rose-50 text-rose-700 ring-rose-200 dark:bg-rose-500/10 dark:text-rose-300 dark:ring-rose-500/20",
      };

    case "Annulé":
      return {
        label: "Annulé",
        className:
          "bg-zinc-100 text-zinc-700 ring-zinc-200 dark:bg-zinc-800 dark:text-zinc-300 dark:ring-zinc-700",
      };

    default:
      return {
        label: status || "Non renseigné",
        className:
          "bg-slate-100 text-slate-700 ring-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:ring-slate-700",
      };
  }
}

export function isReglementValidated(status) {
  return status === "Réglé" || status === "Partiellement réglé";
}